import React from "react"

import StoryblokLink from "../../internal/storyblokLink/StoryblokLink"

const SolidCtaButton = ({ buttonProps }) => {
  return (
    <div>
      {/* Handles if the CTA button links to a modal or if it's going to a url */}
      {buttonProps.isModal ? (
        <button
          className="btn light-blue-solid"
          href="#"
          datapropmodal={buttonProps.modalId}
        >
          {buttonProps.text}
        </button>
      ) : (
        <StoryblokLink text={buttonProps.text} withClass="btn light-blue-solid" SBLinkData={buttonProps.url} />
      )}
      
    </div>
  )
}

export default SolidCtaButton
